import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Field, Input } from "./common";

export function strength(pw) {
  let s = 0;
  if (pw.length >= 12) s++;
  if (pw.length >= 16) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw) || / /.test(pw)) s++;
  return pw.length < 12 ? Math.min(s, 1) : s;
}
const LBL = ["Too short", "Weak", "Fair", "Good", "Strong", "Very strong"];
const COL = ["#B91C1C", "#B91C1C", "#D97706", "#CA8A04", "#2D6A4F", "#1B5E3F"];

export function SecretInput({ value, onChange, testid, label, autoComplete = "new-password" }) {
  const [show, setShow] = useState(false);
  return (
    <Field label={label}>
      <div className="relative">
        <Input data-testid={testid} type={show ? "text" : "password"} autoComplete={autoComplete} value={value} onChange={onChange} className="pr-14" />
        <button type="button" onClick={() => setShow(!show)} aria-label={show ? "Hide password" : "Show password"} data-testid={`${testid}-toggle`}
          className="absolute right-2 top-1/2 -translate-y-1/2 h-10 w-10 inline-flex items-center justify-center text-[#5C4033]">{show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}</button>
      </div>
    </Field>
  );
}

export function PasswordFields({ pw, setPw, confirm, setConfirm }) {
  const s = strength(pw);
  return (
    <div className="space-y-4">
      <SecretInput label="New GKK-FMIS password (at least 12 characters)" value={pw} onChange={(e) => setPw(e.target.value)} testid="new-password-input" />
      <div data-testid="password-strength">
        <div className="h-2 rounded bg-[#E4DACD]"><div className="h-2 rounded transition-[width] duration-300" style={{ width: `${(s / 5) * 100}%`, background: COL[s] }} /></div>
        <p className="text-sm mt-1" style={{ color: COL[s] }}>{pw ? LBL[s] : "Tip: a short sentence you can remember, e.g. “Purok 5 chapel bell rings at six”"}</p>
      </div>
      <SecretInput label="Type the password again" value={confirm} onChange={(e) => setConfirm(e.target.value)} testid="confirm-password-input" />
      {confirm && confirm !== pw && <p className="text-sm text-[#B91C1C]" data-testid="password-mismatch">The two passwords do not match.</p>}
    </div>
  );
}

export const pwReady = (pw, confirm) => pw.length >= 12 && pw === confirm && strength(pw) >= 2;
